import axios from "axios";

const configURLS = {
  production: {
    baseURL: "https://api.riseos.care/api",
    appURL: "https://admin.riseos.care/",
  },
  staging: {
    baseURL: "https://staging-api.riseos.care/api",
    appURL: "https://staging-admin.riseos.care/",
  },
  local: {
    baseURL: "http://192.168.100.150:5000/api",
    // baseURL: "http://localhost:5000/api",
    appURL: "http://localhost:3000",
  },
};

const environment = "production"; // staging, production, local

export const app_url = configURLS[environment].appURL;
export const base_url = configURLS[environment].baseURL;

export const publicAPI = axios.create({
  baseURL: configURLS[environment].baseURL,
});

export const privateAPI = axios.create({
  baseURL: configURLS[environment].baseURL,
});

// Set authorization header dynamically when needed
privateAPI.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export const editorApiKey = "gmvut1nu5d7383bcjl6a996t8adnliadaemcvq7l064xe280";
